
const ENIndicatorsPanel = {
	"Alterar metas que aparecem no gráfico": "Change goals that appear on the chart",
	"Análise FCA realizada": "FCA analysis performed",
	"Análise FCA pendente": "Pending FCA analysis",
	"Classificação do indicador": "Indicator classification",
	"Compartilhar indicadores": "Share indicators",
	"Conforme indicador": "As indicator",
	"Considerar período no cálculo": "Consider period in calculation",
	"Deseja realmente marcar para atualizar os valores do indicador": "Do you really want to mark to update indicator values",
	"Deseja realmente marcar para atualizar os valores dos indicadores": "Do you really want to mark to update the indicators values",
	"Detalhes do indicador": "Indicator details",
	"Eixo Y direito": "Right Y axis",
	"Eixo Y esquerdo": "Left Y axis",
	"Erro ao atualizar valores do indicador": "Error updating indicator values",
	"Erro ao atualizar valores dos indicadores": "Error updating indicators values",
	"Erro ao buscar os detalhes dos indicadores": "Error fetching indicator's details",
	"Erro ao buscar os valores do período": "Error fetching the values of the period",
	"Erro ao buscar valores dos indicadores": "Error fetching indicator's values",
	"Erro ao gerar link de compartilhamento": "Error generating share link",
	"estratégico(s)": "strategic",
	"Forma de avaliação": "Form of evaluation",
	"Gráfico de indicador": "Indicator chart",
	"Grupo de apresentação": "Presentation group",
	"Hierarquia de indicadores": "Indicators hierarchy",
	"Link gerado com sucesso": "Link successfully generated",
	"Meus indicadores": "My indicators",
	"Meta melhoria": "Improvement goal",
	"Mostrar meta competitividade": "Show competitiveness goal",
	"Mostrar meta compromisso": "Show commitment goal",
	"Mostrar meta melhoria": "Show improvement goal",
	"não foi informado": "was not informed",
	"operacional(s)": "operational",
	"Outros campos": "Other fields",
	"Painel de Indicadores" : "Indicators Panel",
	"Plano orçamentário": "Budget plan",
	"Selecionar indicadores": "Select indicators",
	"Selecione ao menos um indicador": "Select at least one indicator",
	"Selecione ao menos um indicador para compartilhar": "Select at least one indicator to share",
	"Será feito na próxima execução da integração": "It will be done in the next integration run",
	"tático(s)": "tactic",
	"Todos indicadores": "All indicators",
	"Válido até": "Valid until",
	"Validade inválida": "Invalid validity",
	"Valor do indicador": "Indicator's value",
	"Valores do indicador marcados para atualizar com sucesso": "Indicator values ​​marked to update successfully",
	"Valores dos indicadores marcados para atualizar com sucesso": "Indicators values ​​marked to update successfully",
	"Valores do período": "Values of period",
	"Valores do período atualizados com sucesso": "Period values ​​successfully updated",
	"Valor Novo":"New Value",
	"Valor Anterior":"Old value"

};

export const ENIndicatorWorkspace = {
	"Estratégico": "Strategic",
	"Indicadores estratégicos": "Strategics indicators",
	"Operacional": "Operational",
	"Sem classificação": "No classification",
	"Sem grupo de apresentação": "Without presentation group",
	"Sem objetivo": "No objective",
	"Sem perspectiva": "No perspective",
	"Sem plano orçamentário": "Without budget plan",
	"Sem mapa estratégico": "No strategy map",
	"Sem setor": "No sector",
	"Tático": "Tactic"
};

export const BRIndicatorWorkspace = {

};

export default ENIndicatorsPanel;
